// extracted by mini-css-extract-plugin
export var content = "_cw-3";
export var list = "_cw-4";
export var settingsContent = "_cw-7";
export var settingsPanel = "_cw-8";
export var state = "_cw-6";
export var triggerBadge = "_cw-2";
export var triggerButton = "_cw-1";
export var triggerShell = "_cw-0";
export var unreadDot = "_cw-5";